module.exports = __webpack_public_path__ + "media/images/android-chrome-384x384-f3b34019.png";